import React, { useState } from "react";
import FAQItem from "./FAQItem";

const FAQSubCategory = ({ subcategory }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="ml-4">
      <button
        onClick={() => setOpen(!open)}
        className="md:text-3xl bg-dark-gray text-white px-4 py-2 rounded-lg w-full text-left flex items-center justify-between"
      >
        {subcategory.title}
        <img
          src="/images/arrows/flecha2.webp"
          alt="toggle"
          className={`h-4 w-6 transition-transform duration-200 ${open ? "rotate-180" : ""}`}
        />
      </button>

      {open && (
        <div className="mt-2 space-y-2">
          {subcategory.items.map((item, idx) => (
            <FAQItem key={idx} question={item.question} answer={item.answer} />
          ))}
        </div>
      )}
    </div>
  );
};

export default FAQSubCategory;
